var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.549,
    height: 20,
    viewBox: "0 0 20.549 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16",
    transform: "translate(0.023 -6.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67627",
    "data-name": "Path 67627",
    d: "M14.4,17.827a.762.762,0,0,0-.822.7c-.067.8-.151,1.487-.224,1.851v0a3.363,3.363,0,0,1-2.348,2.452l-.281.055c.08-1.032.14-2.353.132-3.371a45.116,45.116,0,0,0-.269-4.9,7.169,7.169,0,0,0-2.51-4.528l-.007,0A13.571,13.571,0,0,0,5.422,8.686q-.25-.1-.493-.181A17.1,17.1,0,0,1,7.6,8.3a16.568,16.568,0,0,1,3.4.333,3.362,3.362,0,0,1,2.348,2.452v0c.073.361.156,1.053.224,1.846a.763.763,0,0,0,1.52-.129c-.073-.858-.163-1.592-.247-2.014a4.877,4.877,0,0,0-3.52-3.649l-.01,0A18.29,18.29,0,0,0,7.6,6.779a17.772,17.772,0,0,0-3.716.366l-.01,0A4.521,4.521,0,0,0,1.821,8.266a1.9,1.9,0,0,0-.415.431A4.648,4.648,0,0,0,.356,10.8a32.132,32.132,0,0,0-.378,4.937c-.009.861.047,1.953.13,2.922.044.622.094,1.164.142,1.511a7.168,7.168,0,0,0,2.51,4.528l.007,0A13.587,13.587,0,0,0,5.42,26.092a10.369,10.369,0,0,0,2.65.68h.007a2.563,2.563,0,0,0,2.463-2.309q.394-.063.78-.142l.01,0a4.876,4.876,0,0,0,3.52-3.649c.084-.423.175-1.158.248-2.019a.762.762,0,0,0-.695-.824Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67628",
    "data-name": "Path 67628",
    d: "M305.813,146.335a.482.482,0,0,0,0-.076.021.021,0,0,0,0,0,.7.7,0,0,0-.011-.071v-.005a.758.758,0,0,0-.207-.382l-2.729-2.731a.763.763,0,0,0-1.079,1.078l1.431,1.431h-5.263a.762.762,0,1,0,0,1.525h5.257l-1.43,1.43a.762.762,0,0,0,1.078,1.078l2.716-2.716a.757.757,0,0,0,.209-.339.66.66,0,0,0,.017-.07.079.079,0,0,0,0-.01c0-.02.007-.04.009-.062a.361.361,0,0,0,0-.047v-.026Z",
    transform: "translate(-285.287 -130.603)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7ebc090276cf64265ba96b79f85f46e5.svg";
export { ForwardRef as ReactComponent };